import type { KpiCardSpec } from '../kpis/card-spec';

/**
 * The one section on this page served by the analytics envelope. The
 * remaining seven groups are hand-built from `carWashStore.transactionStats`,
 * a different endpoint that is not part of this migration, so this page is
 * deliberately mixed rather than half-converted.
 *
 * All three counters are national grain (`carwash-engagement` declares
 * `regionGrain: 'national'`): one fetch serves every region, and a per-region
 * fan-out summed on top reads double (see `sources/carwash-engagement.ts`).
 */
export const ENGAGEMENT_CARDS: KpiCardSpec[] = [
    {
        title: 'Wash code generated',
        source: 'carwash-engagement',
        metric: 'washCodesGenerated',
        form: 'number',
        size: 'sm',
    },
    {
        title: 'Beacon generated',
        source: 'carwash-engagement',
        metric: 'beaconsGenerated',
        form: 'number',
        size: 'sm',
    },
    {
        title: 'Beacon requested',
        source: 'carwash-engagement',
        metric: 'beaconsRequested',
        form: 'number',
        size: 'sm',
    },
];
